import { Component } from '@angular/core';

@Component({
  selector: 'lib-survey-layout',
  styleUrls: ['./survey-layout.component.scss'],
  template: ` <ng-content></ng-content> `,
  standalone: true,
})
export class SurveyLayoutComponent {}
